export const COLORS = {
  WHITE: '#FFFFFF',
  PRIMARY_DARK: '#303342',
  PRIMARY_LIGHT: '#F1F5FA',
  BLUE: '#3547E4',
  ORANGE: '#E78933',
  GRAY_1: '#EBECF3',
  GRAY_2: '#A1A4B1',
  GRAY_3: '#E5E5E5',
  GRAY_4: '#505565',
  DANGER: '#DF4A4A',
  BLACK_1: '#1F1D1D',
  BLACK_2: '#171717',
  PURPLE: '#394CE4',
  RED: '#CB0000',
  ORANGE_2: '#E74933',
  BLUE_DIM: '#576675',
  MORCHANA_BLUE: '#00A0D7',
}

export const FONT_FAMILY = "'Prompt', sans-serif"
